import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios';
import { ApiUrl, Headers } from '../services/ApiUrl';
import { useSystemOptionsStore } from '../stores/useOptions';


const SystemOptionsForm = () => {
    const { updateSystemOptions } = useSystemOptionsStore();
    const [votacionActiva, setVotacionActiva] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [alert, setAlert] = useState({ show: false, variant: '', message: '' });

    useEffect(() => {
        const fetchOpciones = async () => {
            try {
                const url = ApiUrl + 'getopciones';
                const response = await axios.get(url, { headers: Headers });
                
                if (response.data.error) {
                    throw new Error(response.data.mensaje);
                }

                const votacionValue = response.data.opciones.voto_activo.valor === "1";
                setVotacionActiva(votacionValue);
                
                updateSystemOptions({
                    votacionActiva: votacionValue ? 1 : 0
                });

            } catch (error) {
                setAlert({
                    show: true,
                    variant: 'danger',
                    message: 'Error al cargar las opciones del sistema'
                });
                console.error('Error al cargar opciones:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchOpciones();
    }, [updateSystemOptions]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setAlert({ show: false, variant: '', message: '' });

        const formData = new FormData();
        formData.append('table', 'actualizaropciones');
        formData.append('id_opcion', '1');
        formData.append('valor', votacionActiva ? '1' : '0');

        try {
            const response = await axios.post(ApiUrl+'actualizaropciones', formData, { headers: Headers });

            if (response.data.error) {
                throw new Error(response.data.mensaje);
            }

            updateSystemOptions({
                votacionActiva: votacionActiva ? 1 : 0
            });

            setAlert({
                show: true,
                variant: 'success',
                message: 'Opciones actualizadas correctamente'
            });

        } catch (error) {
            setAlert({
                show: true,
                variant: 'danger',
                message: error.message || 'Error al actualizar las opciones'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    if (isLoading) {
        return (
            <Card className="shadow-sm">
                <Card.Body className="text-center py-5">
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-2 mb-0">Cargando opciones...</p>
                </Card.Body>
            </Card>
        );
    }

    return (
        <Card className="shadow-sm">
            <Card.Header as="h5" className="bg-primary text-white">
                Configuración del Sistema
            </Card.Header>
            <Card.Body>
                {alert.show && (
                    <Alert 
                        variant={alert.variant} 
                        dismissible 
                        onClose={() => setAlert({ show: false, variant: '', message: '' })}
                    >
                        {alert.message}
                    </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                    <div className="option-container p-4 mb-4 rounded">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <div>
                                <h5 className="mb-0">Votación Activa</h5>
                                <small className="text-muted">
                                    Activa o desactiva el sistema de votación para todos los usuarios.
                                </small>
                            </div>
                            <div className="custom-switch-container">
                                <Form.Check
                                    type="switch"
                                    id="votacion-switch"
                                    className="custom-switch"
                                    checked={votacionActiva}
                                    onChange={(e) => setVotacionActiva(e.target.checked)}
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>
                        <div className="status-indicator mt-2">
                            <span className={`status-badge ${votacionActiva ? 'active' : 'inactive'}`}>
                                {votacionActiva ? 'Activado' : 'Desactivado'}
                            </span>
                        </div>
                    </div>

                    <div className="d-grid gap-2">
                        <Button 
                            type="submit" 
                            variant="primary"
                            disabled={isSubmitting}
                            style={{width:'300px'}}
                            
                        >
                            {isSubmitting ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-2"
                                    />
                                    Guardando...
                                </>
                            ) : 'Guardar Cambios'}
                        </Button>
                    </div>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default SystemOptionsForm;